import { Injectable } from '@angular/core';

import { MwService } from '~app/shared/services/mw/mw.service';
import { DataUtilsService } from '../services/data-utils/data-utils.service';

@Injectable()
export class ShipListResolver {
  constructor(private readonly mw: MwService, private readonly dataUtils: DataUtilsService) {}

  public async resolve(): Promise<any> {
    await this.dataUtils.ensureShips();
    return this.mw.getShipList().toPromise();
  }
}
